import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as countriesActions from '../actions/countries.actions';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwCountriesApiService } from 'app/services/countries-api.service';

@Injectable()
export class CountriesEffects {
  loadCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(countriesActions.loadCountries),
      switchMap(() =>
        this.countriesApiService.getCountries().pipe(
          map((items) => countriesActions.loadCountriesSuccess({ items })),
          catchError((error) =>
            of(countriesActions.loadCountriesFailed({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private countriesApiService: MwCountriesApiService
  ) {}
}
